import { CrewRoster } from '@/components/crewroster/CrewRoster';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const rosterSearchSchema = z.object({
  tab: z.enum(['calendar', 'list', 'gantt']).optional().default('gantt'),
  selectedMonth: z.string().optional(),
  filterCrewIds: z.array(z.string()).optional(),
  filterDutyStatuses: z.array(z.string()).optional(),
  filterAircraftIds: z.array(z.string()).optional(),
});

export const Route = createFileRoute('/_auth/operations/rosters/')({
  validateSearch: rosterSearchSchema,
  component: CrewRoster,
});
